import request from './request'

export function search(data) {
    return request({
        url: '/api/caseCard/list',
        method: 'get',
        params: data
    })
}
